import { lazy, Suspense } from 'react';
import Loader from '../custom/loader/main'

const Main = lazy(() => import('../components/configure/session/main'))
const Session = () =>{
return(
    <Suspense fallback={<Loader/>}>
        <Main/>
    </Suspense>
)



}

export default Session;